import { useTranslate } from '@festina-life/ui/hooks'

import { useScenarioContext } from '../../context/scenarioContext'
import { useScenarioAndVariant } from '../../hooks/useScenarios'
import { useHook } from '../../lenteHooks'

export const AddToScenarioLabel = () => {
  const translate = useTranslate()

  const { variantIdentifier } = useScenarioContext()
  const { tenantId, ownerId } = useHook('routing.general.useEntityParams')()

  const { scenario: currentSelectedScenario, variant: currentSelectedVariant } =
    useScenarioAndVariant({
      tenantId,
      ownerId,
      scenarioId: variantIdentifier?.scenarioId,
      variantId: variantIdentifier?.variantId,
    })

  if (
    currentSelectedScenario?.scenarioTitle &&
    currentSelectedVariant?.variantTitle
  ) {
    return translate('commitmentScenario.modal.add', {
      scenarioTitle: currentSelectedScenario.scenarioTitle ?? '',
      variantTitle: currentSelectedVariant.variantTitle ?? '',
    })
  } else {
    return translate('commitmentScenario.modal.addUnknown')
  }
}
